const DEFAULT_DATE_FORMAT = 'MMM DD, YYYY'

export {
    DEFAULT_DATE_FORMAT
}
